import { useState, useEffect } from 'react';

interface Settings {
  systemConfig: {
    domain: string;
    invalidTokenRedirect: string;
    tokenPrefix: string;
  };
  aiPrompts: {
    companySummary: string;
    recommendations: string;
    digitalScore: string;
  };
  seoConfig: {
    testMode: boolean;
    metaNoIndex: boolean;
    defaultTitle: string;
    defaultDescription: string;
    defaultKeywords: string;
    ogSiteName: string;
    ogImage: string;
    twitterSite: string;
    sitemapRoutes: string;
  };
  robotsConfig: {
    content: string;
    active: boolean;
  };
}

interface SettingsError {
  message: string;
  code?: string;
}

export function useSettings() {
  const [settings, setSettings] = useState<Settings | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<SettingsError | null>(null);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setIsLoading(true);
      // TODO: Implémenter le chargement depuis l'API
      const mockSettings: Settings = {
        systemConfig: {
          domain: 'https://app.smart-impact.ch',
          invalidTokenRedirect: 'https://smart-impact.ch',
          tokenPrefix: '/t/'
        },
        aiPrompts: {
          companySummary: '',
          recommendations: '',
          digitalScore: ''
        },
        seoConfig: {
          testMode: false,
          metaNoIndex: false,
          defaultTitle: 'Cold Sales System',
          defaultDescription: '',
          defaultKeywords: '',
          ogSiteName: '',
          ogImage: '',
          twitterSite: '',
          sitemapRoutes: ''
        },
        robotsConfig: {
          content: '',
          active: true
        }
      };
      setSettings(mockSettings);
      setError(null);
    } catch (err) {
      setError({
        message: err instanceof Error ? err.message : 'Une erreur est survenue',
        code: 'LOAD_ERROR'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const updateSettings = async (newSettings: Settings) => {
    try {
      // TODO: Implémenter la sauvegarde vers l'API
      setSettings(newSettings);
      return true;
    } catch (err) {
      setError({
        message: err instanceof Error ? err.message : 'Erreur lors de la sauvegarde',
        code: 'SAVE_ERROR'
      });
      return false;
    }
  };

  return {
    settings,
    updateSettings,
    isLoading,
    error
  };
}

export default useSettings;
